export default __webpack_public_path__ + "static/link-style-6b57650b865d729efe883f1bdac8d413.png";